import { render, staticRenderFns } from "./RecurringNotLegislatedForm.vue?vue&type=template&id=6f9f8700"
import script from "./RecurringNotLegislatedForm.vue?vue&type=script&lang=js"
export * from "./RecurringNotLegislatedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports